import React from 'react'
import CollapsibleAttributeTree from './CollapsibleAttributeTree'

const CollapsibleCheckbox = (props) => <CollapsibleAttributeTree mode="checkbox" {...props} />

export default CollapsibleCheckbox
